import { fetchGlobalBudget, saveGlobalBudget, deleteGlobalBudget } from '../../api/budgets.js';
import { showToast } from '../../utils/toast.js';

export function initBudgetManager() {
    const btnSettings = document.getElementById('btn-settings-manage-budgets');
    if (btnSettings) btnSettings.addEventListener('click', openBudgetManager);

    const modal = document.getElementById('budget-manager-modal');
    const content = document.getElementById('budget-manager-content');
    const btnClose = document.getElementById('btn-close-budget-manager');
    const btnSave = document.getElementById('btn-budget-add-save');
    const btnDelete = document.getElementById('btn-budget-delete-edit');
    const btnCancel = document.getElementById('btn-budget-add-cancel');
    const amountInput = document.getElementById('budget-amount-input');
    const addError = document.getElementById('budget-add-error');
    
    // Ẩn dropdown category không cần thiết trên HTML
    const catSelect = document.getElementById('budget-cat-select');
    if (catSelect) catSelect.style.display = 'none';

    if (!modal) return;

    const closeModal = () => {
        content.classList.add('translate-y-full');
        content.classList.remove('translate-y-0');
        setTimeout(() => { modal.classList.add('hidden'); modal.classList.remove('flex'); }, 300);
    };

    btnClose.addEventListener('click', closeModal);
    btnCancel.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });

    // Xóa Limit
    btnDelete.addEventListener('click', async () => {
        if (!confirm('Remove global spending limit?')) return;
        btnDelete.disabled = true;
        btnDelete.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i>';
        
        const ok = await deleteGlobalBudget();
        if (ok) {
            showToast('Limit removed', 'success');
            closeModal();
            if (window.refreshAllActiveViews) window.refreshAllActiveViews();
        } else {
            showToast('Failed to remove limit', 'error');
        }
        btnDelete.disabled = false;
        btnDelete.innerHTML = '<i class="fa-solid fa-trash"></i>';
    });

    // Lưu Limit
    btnSave.addEventListener('click', async () => {
        const amountStr = amountInput.value.replace(/,/g, '');
        const amount = Number(amountStr);

        if (!amount || amount <= 0) { 
            addError.innerText = 'Please enter a valid amount.'; 
            addError.classList.remove('hidden'); 
            return; 
        }

        btnSave.innerText = 'Saving...'; btnSave.disabled = true;
        const result = await saveGlobalBudget(amount);
        btnSave.innerText = 'Save Limit'; btnSave.disabled = false;

        if (result) {
            showToast('Global limit updated!', 'success');
            closeModal();
            if (window.refreshAllActiveViews) window.refreshAllActiveViews();
        } else {
            addError.innerText = 'Cannot connect to server. Try again.';
            addError.classList.remove('hidden');
        }
    });

    // Format tiền tệ khi gõ
    amountInput.addEventListener('blur', () => {
        const val = amountInput.value.replace(/,/g, '');
        if (val) amountInput.value = Number(val).toLocaleString('en-US');
    });
    amountInput.addEventListener('focus', () => {
        amountInput.value = amountInput.value.replace(/,/g, '');
    });
}

// Mở Modal
async function openBudgetManager() {
    const modal = document.getElementById('budget-manager-modal');
    const content = document.getElementById('budget-manager-content');
    
    // Ép giao diện chỉ hiện ô nhập liệu
    document.getElementById('budget-add-bar').classList.remove('hidden');
    document.getElementById('budget-list').classList.add('hidden');
    document.getElementById('btn-budget-add-new').classList.add('hidden');
    document.getElementById('budget-add-title').innerText = 'Set Monthly Limit';

    const amountInput = document.getElementById('budget-amount-input');
    const btnDelete = document.getElementById('btn-budget-delete-edit');
    
    amountInput.value = '';
    btnDelete.classList.add('hidden');
    document.getElementById('budget-add-error').classList.add('hidden');

    modal.classList.remove('hidden');
    modal.classList.add('flex');
    setTimeout(() => {
        content.classList.remove('translate-y-full');
        content.classList.add('translate-y-0');
    }, 10);

    // Tải dữ liệu limit hiện tại (nếu có)
    const currentBudget = await fetchGlobalBudget();
    if (currentBudget) {
        amountInput.value = Number(currentBudget.monthly_amount).toLocaleString('en-US');
        btnDelete.classList.remove('hidden');
        document.getElementById('btn-budget-add-save').innerText = 'Update Limit';
    } else {
        document.getElementById('btn-budget-add-save').innerText = 'Save Limit';
    }
}